import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet'
import { Router } from '@angular/router'
import { TranslationService } from '../../../../../../services/translation.service'
import { GhsClassification } from '../../../../../../types/ghs'
import { NgOptimizedImage } from '@angular/common'
import { MatDivider } from '@angular/material/divider'
import { MatListModule } from '@angular/material/list'
import { CommonService } from '../../../../../../services/common.service'

@Component({
  selector: 'app-ghs-sheet',
  imports: [MatListModule, MatDivider, NgOptimizedImage],
  templateUrl: './ghs-sheet.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './ghs-sheet.component.scss',
})
export class GhsSheetComponent {
  data = inject(MAT_BOTTOM_SHEET_DATA)
  router = inject(Router)
  translationService = inject(TranslationService)
  commonService = inject(CommonService)

  ghsClassifications: Array<GhsClassification> = []

  // the object injected below has to be any since 'data' is dynamic

  constructor() {
    const data = this.data

    if (data.ghsClassifications) {
      this.ghsClassifications = data.ghsClassifications
    }
  }

  /**
   * Returns file path for a GHS classification image
   * @param {string} ghsName Name of GHS classification
   * @returns {string} The file path
   */
  getGhsImgPath(ghsName: string): string {
    const ghsMap: Record<string, string> = {
      explosive: 'GHS01',
      flammable: 'GHS02',
      oxidizing: 'GHS03',
      'compressed gas': 'GHS04',
      corrosive: 'GHS05',
      toxic: 'GHS06',
      harmful: 'GHS07',
      'health hazard': 'GHS08',
      'environmental hazard': 'GHS09',
    }

    const normalizedKey = ghsName.trim().toLowerCase()
    const ghsCode = ghsMap[normalizedKey]

    if (!ghsCode) {
      throw new Error(`Invalid GHS classification name: ${ghsName}`)
    }

    return `assets/ghs/${ghsCode.toLowerCase()}.svg`
  }
}
